export class ZipCodeQueryResponse {
  areaCodes = '';
  branchName = '';
  branchZipCode = '';
  country = '';
  county = '';
  latitude = 0;
  longitude = 0;
  primaryCity = '';
  state = '';
  zip = '';

  static fromJSON(map) {
    const instance = new ZipCodeQueryResponse();
    instance.areaCodes = map['area_codes'];
    instance.branchName = map['branch_name'];
    instance.branchZipCode = map['branch_zip'];
    instance.country = map['country'];
    instance.county = map['county'];
    instance.latitude = map['latitude'];
    instance.longitude = map['longitude'];
    instance.primaryCity = map['primary_city'];
    instance.state = map['state'];
    instance.zip = map['zip'];
    return instance;
  }
}
